<div class="flex items-center justify-center min-h-screen bg-gray-100">
      <div class="w-full max-w-md mx-4">
        <div class="overflow-hidden bg-white shadow-lg rounded-xl">
          <div class="px-6 py-8 text-center bg-gradient-to-r from-red-500 to-orange-500">
            <svg class="w-20 h-20 mx-auto text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
            </svg>
            <h1 class="mt-4 text-2xl font-bold text-white">Licence inactive</h1>
          </div>
          <div class="p-6 text-center">
            <p class="mb-4 text-gray-600">
              Votre licence est expirée ou inactive. Vous ne pouvez plus accéder aux fonctionnalités de l'application.
            </p>
            <p class="mb-6 text-sm text-gray-500">
              Veuillez contacter l'administrateur pour renouveler votre licence.
            </p>
            <button (click)="logout()"
                    class="w-full px-4 py-2 text-white transition-colors bg-blue-600 rounded-lg hover:bg-blue-700">
              Se déconnecter
            </button>
          </div>
        </div>
      </div>
    </div>
